export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin'],
                headerSize: 'large',
                header1: 'About us',
                text2: "<p>Our tech is advanced, but our beliefs are simple.</p><p>Already from the start we set out to be the slap in the face we believe the online and tech industry needs.</p><p>We fight for fair e-com, providing a new generation of online retail on the terms of sellers, content creators and customers online.</p>",
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                blockModifiers: ['headerMargin'],
                header1: 'Location / Offices',
                text2: "<p>Our headquarter is based in Luleå close to the arctic circle in the north of Sweden. Offices are also located in Stockholm and in Dhaka, Bangladesh.</p>",
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','centerAlignText','detailText'],
                img1: {
                  blockModifiers: ['circleMask'],
                  src: 'offices_Lulea.jpg',
                  alt: 'Spotin Luleå office',
                },
                text1: "<p>Luleå office, Sweden</p>",
                img2: {
                  blockModifiers: ['circleMask'],
                  src: 'offices_Sthlm.jpg',
                  alt: 'Spotin Stockholm Office',
                },
                text2: "<p>Stockholm office, Sweden</p>",
                img3: {
                  blockModifiers: ['circleMask'],
                  src: 'offices_Dhaka.jpg',
                  alt: 'Spotin Dhaka office',
                },
                text3: "<p>Dhaka office, Bangladesh</p>",
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                header1: 'Our vision',
                text2: "Spotin shall provide a sustainable and long-term business model for the online media industry by providing novel and rewarding customer experiences for online shopping. In so doing, Spotin shall become a globally recognized and widely used marketing and sales platform by media and suppliers within any market and any industry.",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'Our mission',
                text2: "Create a seamless customer experience for brand and product- discovery, purchase, promotion, and exposure in any online media content. To provide a new generation of online retail to customers that are used to having what they want, when they want it, and at their fingertips.",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        // blockModifiers: ['noPadding'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['centerAlignText'],
                header2: 'Our Journey',
              }
            },
          }
        ]
      }
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        blockModifiers: ['noPadding'],
        sections: [
          {
            full: {
              component: 'circles',
              data: {
                circles: [
                  {
                    header: "2011",
                    text: "First concept design of the Spotin service",
                  },
                  {
                    header: "2015",
                    text: "Founded as Context Sales Sweden",
                  },
                  {
                    header: "2016",
                    text: "<p>First two employees hired</p><p>Established main office in Luleå</p><p>Granted 1,2 MSEK in innovation funding</p>",
                  },
                  {
                    header: "2017",
                    text: "Changed name of company to Spotin AB",
                  },
                  {
                    header: "2018",
                    text: "<p>First integration towards brand</p><p>First (shared) office in Stockholm</p><p>Di Startup Tour Local finalist</p><p>Secured domain Spotin.com</p>",
                  },
                  {
                    header: "2019",
                    text: "<p>SXSW2019 pitch winner, Austin (US)</p><p>Registered Spotin as brand in US</p><p>“Seal of Excellence” from EU Commission</p>",
                  },
                  {
                    header: "2020",
                    text: "<p>Added AI for image optimization</p><p>Official launch with Egmont Publishing</p>",
                  },
                  {
                    header: "2021",
                    text: "<p>Opened Spotin BD LTD in Bangladesh</p><p>New Office in Stockholm</p>",
                  },
                  {
                    header: "2022",
                    text: "<p>First 100 brands signed</p><p>New service design</p><p>US market launch</p>",
                  },
                ]
              }
            },
          }
        ]
      },
    },

    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnOffBlack',
    //     sections: [
    //       {
    //         full: {
    //           component: 'flex-block',
    //           data: {
    //             header1: 'Our journey',
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },

    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnOffBlack',
    //     blockModifiers: ['noPadding'],
    //     sections: [
    //       {
    //         full: {
    //           component: 'animation',
    //           type: 'animation',
    //           data: {
    //             // animationSpeed: 1,
    //             blockModifiers: ['endMargin', 'noMaxWidthHeight'],
    //             src: "Timeline - desktop_100px.json",
    //             srcMobile: "Timeline - mobile_15px.json",
    //           }
    //         }
    //       }
    //     ]
    //   },
    // },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Board of Directors',
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin'],
                img1: {
                  blockModifiers: ['cover'],
                  src: 'People/ceo_Kristoffer_Karlsson_web.jpg',
                  alt: 'Kristoffer Karlsson',
                },
                text1: 'Kristoffer Karlsson, CEO',
                img2: {
                  blockModifiers: ['cover'],
                  src: 'People/CFO_Robert_Karlsson_web.jpg',
                  alt: 'Robert Karlsson',
                },
                text2: 'Robert Karlsson, CFO',
                img3: {
                  blockModifiers: ['cover'],
                  src: 'People/Board_Jonas_Eriksson_web.jpg',
                  alt: 'Jonas Eriksson',
                },
                text3: 'Jonas Eriksson, Board Member',
              }
            },
          }
        ]
      },
    },

    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offBlackOnOffWhite',
    //     sections: [
    //       {
    //         full: {
    //           component: 'flex-block',
    //           data: {
    //             header1: 'Management',
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },


    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offBlackOnOffWhite',
    //     sections: [
    //       {
    //         top: {
    //           component: 'flex-block',
    //           data: {
    //             img1: {
    //               src: 'example_product.png',
    //             },
    //             text1: 'Mgmg1',
    //             img2: {
    //               src: 'example_product.png',
    //             },
    //             text2: 'Mgmg2',
    //             img3: {
    //               src: 'example_product.png',
    //             },
    //             text3: 'Mgmg3',
    //           }
    //         },
    //         bottom: {
    //           component: 'flex-block',
    //           data: {
    //             img1: {
    //               src: 'example_product.png',
    //             },
    //             text1: 'Mgmg4',
    //             img2: {
    //               src: 'example_product.png',
    //             },
    //             text2: 'Mgmg5',
    //             img3: {
    //               src: 'example_product.png',
    //             },
    //             text3: 'Mgmg6',
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },


    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'blueOnSand',
    //     blockModifiers: ['minTopPadding'],
    //     sections: [
    //       {
    //         full: {
    //           component: 'flex-block',
    //           data: {
    //             text1: '<div style="border: none; background-color: #FEF2CD; color: #86680F; font-size: 14px; padding: 15px; border-radius: 10px; margin-top: 10px; width: fit-content !important;"><strong>Order related questions?</strong><br>For questions regarding your order please <a style="text-decoration: underline;" href="/FAQ">see FAQ</a></div>',
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'Contact',
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                text1: '<div style="border: none; background-color: #FEF2CD; color: #86680F; font-size: 14px; padding: 15px; border-radius: 10px; margin-top: 10px; width: fit-content !important;"><strong>Order related questions?</strong><br>Please see the <a style="text-decoration: underline;" href="/ordersupport">order support page</a></div>',
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['noMargin'],
                text1: '<a href="mailto:info@spotin.com?subject=Contact from website" style="text-decoration:underline">info@spotin.com</a>',
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin'],
                text1: '<strong>Main office</strong><br>Spotin AB<br>Rådstugatan 7A<br>972 38 Luleå<br>Sweden<br><br>',
                text2: '<strong>Marketing & Sales</strong><br>Spotin AB<br>Stureplan 6, 3rd floor<br>114 35 Stockholm<br>Sweden'
              }
            }
          }
        ]
      },
    },


  ],
};



// WEBPACK FOOTER //
// ./pages/About.js